module.exports = __webpack_public_path__ + "static/media/Group 21793.50df3a3f.svg";